import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { topicTeacherImgs } from '../../images/topicImg'

export class StyleTwoClassTabsTables extends Component {
  static propTypes = {
    styleTwo: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, onMeiQiaCustomer, colorData } = this.props;

    return (
      <div className="style-two-style-two-class-tabs-tables">
        <div className='class_content_tips_box'>
          <div className='class_info_box flex_row'>
            <div className='class_content_title'>班级介绍</div>
            <div className='class_content_info'>{Data.classInfo}</div>
          </div>
          <div className='class_info_box flex_row'>
            <div className='class_content_title'>配套服务</div>
            <div className='class_content_info assort_service flex_row'>
              {Data.assortService && Data.assortService.map(item => <div className='service_items flex_row' key={item.id}>
                <img src={topicTeacherImgs.class_yes} alt="" />
                <div className='sevice_items_title'>{item.title}</div>
              </div>)}
            </div>
          </div>
          <div className='class_info_box flex_row'>
            <div className='class_content_title letter_space_3'>有效期</div>
            <div className='class_content_info'>{Data.validity}</div>
          </div>
        </div>

        <div className='class_info_tables'>
          <div className='info_tables_tr flex_row' style={{ backgroundColor: `${colorData.opacityColor006}`, border: `1px solid ${colorData.opacityColor01}` }}>
            <div className='info_tables_th flex_row width508' style={{ borderRight: `1px solid ${colorData.opacityColor01}`, color: `${colorData.color}` }}>课程名称</div>
            <div className='info_tables_th flex_row width120' style={{ borderRight: `1px solid ${colorData.opacityColor01}`, color: `${colorData.color}` }}>精讲名师</div>
            <div className='info_tables_th flex_row width110' style={{ borderRight: `1px solid ${colorData.opacityColor01}`, color: `${colorData.color}` }}>课时</div>
            <div className='info_tables_th flex_row width98' style={{ borderRight: `1px solid ${colorData.opacityColor01}`, color: `${colorData.color}` }}>价格</div>
            <div className='info_tables_th flex_row width180' style={{ borderRight: `1px solid ${colorData.opacityColor01}`, color: `${colorData.color}` }}>免费体验</div>
            <div className='info_tables_th flex_row width120' style={{ color: `${colorData.color}` }}>报名</div>
          </div>
          {Data.courseList && Data.courseList.map(item => <div className='info_tables_td_tr flex_row' key={item.id} style={{ border: `1px solid ${colorData.opacityColor01}` }}>
            <div className='info_tables_td flex_row width508' style={{ borderRight: `1px solid ${colorData.opacityColor01}` }}>{item.title}</div>
            <div className='info_tables_td flex_row width120' style={{ borderRight: `1px solid ${colorData.opacityColor01}` }}>{item.teacher}</div>
            <div className='info_tables_td flex_row width110' style={{ borderRight: `1px solid ${colorData.opacityColor01}` }}>{item.classHour}</div>
            <div className='info_tables_td flex_row width98' style={{ borderRight: `1px solid ${colorData.opacityColor01}` }}>{item.price}</div>
            <div className='info_tables_td flex_row width180 price' style={{ borderRight: `1px solid ${colorData.opacityColor01}` }}>{item.experience}<img style={{ marginLeft: '8px' }} src={item.icon} alt="" /></div>
            <div className='info_tables_td flex_row width120'>
              <div className='apply_btn flex_row' onClick={onMeiQiaCustomer}>报名</div>
            </div>
          </div>)}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    styleTwo: state.styleTwo,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoClassTabsTables);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoClassTabsTables.js